import { Button } from "@themesberg/react-bootstrap";
import React from "react";

export const TableRow = (props) => {
  const {
    ticket,
    user,
    netValue,
    fee,
    tax,
    isPaid,
    id,
    grossValue,
  } = props.data;

  const { onPaidPress } = props;
  const numberFormatter = new Intl.NumberFormat("vn-VI", {});

  return (
    <tr>
      <td className="text-center">
        <Button onClick={() => props.onShowDetailPress(props.data)}>
          Chi tiết
        </Button>
      </td>
      <td>
        {(user && user.name) || ""}
        <br />
        <span>
          <strong className={`text-primary`}>
            {(user && user.phone) || ""}
          </strong>
        </span>
      </td>
      <td className="text-center">{ticket.ClassicCartId}</td>
      <td className="text-center">
        {ticket.ClassicLotteryChannel.name}
        <br />
        {ticket.ClassicResult.resultDate}
      </td>
      <td className="text-center">
        <div className="fw-bold">
          {ticket.ClassicLotteryStorage && ticket.ClassicLotteryStorage.numbers
            ? ticket.ClassicLotteryStorage.numbers.split("").join(" ")
            : ticket.ClassicLotteryStorageId.slice(-6)}
        </div>
        {ticket.ClassicLotteryStorage && ticket.ClassicLotteryStorage.symbol
          ? <div>{ticket.ClassicLotteryStorage.symbol}</div>
          : null}
        <div>{"x " + ticket.amount + " tờ"}</div>
      </td>
      <td className="text-center text-success">{numberFormatter.format(grossValue || 0)}</td>
      <td className="text-center">{numberFormatter.format(tax || 0)}</td>
      <td className="text-center">{numberFormatter.format(fee || 0)}</td>
      <td className="text-center text-primary">{numberFormatter.format(netValue || 0)}</td>
      <td className="text-center text-success">
        {isPaid ? (
          "Đã trả thưởng"
        ) : (
          <Button
            className="btn-danger m-1"
            onClick={() => onPaidPress(id, user.phone, ticket.id)}
          >
            Trả thưởng
          </Button>
        )}
      </td>
    </tr>
  );
};